import { cssThemedValue, pxToRem } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, Redirect } from 'react-router-dom';
import styled from 'styled-components';

import { Body1, Heading2 } from 'common/typography/Typography';
import Loading from 'core/Loading';
import useGetVenues from 'modules/experience/components/Search/hooks/useGetVenues';

import { CreateAdCampaignVenueListItem } from './CreateAdCampaignVenueListItem';

const getUrl = (venueSlug: string) => `/venue/${venueSlug}/campaigns/new?campaignType=Ads`;

// Copied from 'modules/front-page/FrontPageTemplate
const Root = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 648px;
  margin: 0 auto;
  margin-block-end: 80px;
  padding-inline-start: 32px;
  padding-inline-end: 32px;
  background-color: ${cssThemedValue('surfaceMain')};
  margin-block-start: 80px;

  @media (width <= 640px) {
    width: 100%;
    text-align: center;
    padding-inline-start: 16px;
    padding-inline-end: 16px;
  }
`;

const StyledHeading = styled(Heading2)`
  padding-block-end: ${pxToRem(24)};
`;

const StyledBody = styled(Body1)`
  padding-block-end: ${pxToRem(8)};
`;

export const CreateAdCampaignDeeplink = () => {
  const { isLoading, venues } = useGetVenues(true);

  if (isLoading) {
    return <Loading />;
  }

  if (venues.length === 0) {
    return (
      <Root>
        <StyledHeading>
          <FormattedMessage id="campaigns.ads.deeplink.error-title" />
        </StyledHeading>
        <StyledBody>
          <FormattedMessage id="campaigns.ads.deeplink.error-description" />
        </StyledBody>
        <Link to="/">
          <StyledBody>
            <FormattedMessage id="campaigns.ads.deeplink.error-back-to-frontpage" />
          </StyledBody>
        </Link>
      </Root>
    );
  }

  if (venues.length === 1) {
    return <Redirect to={getUrl(venues[0].slug)} />;
  }

  return (
    <Root>
      <StyledHeading>
        <FormattedMessage id="campaigns.ads.deeplink.title" />
      </StyledHeading>
      {venues.map(venue => (
        <Link to={getUrl(venue.slug)} key={venue.slug}>
          <CreateAdCampaignVenueListItem
            label={venue.name[0].value}
            subLabel={venue.address}
            listImage={venue.listimage ?? undefined}
          />
        </Link>
      ))}
    </Root>
  );
};
